import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../modules/tornado/utils/style';
import { middle, identity } from '../../modules/tornado/utils/sizes';
import { ICON_TYPE } from '../../modules/tornado/icon/icon.constants';

const defaultContext = makeDefaultStylingContext();

export const SIZE = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const ICON_SIZE = {
  [HD]: 12,
  [FULL_HD]: 12,
};

export const colors = {
  primary: makeThemeColor(PRIMARY),
  primaryDisabled: makeThemeColor(PRIMARY, 0.3),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    w: SIZE[screenSize],
    h: SIZE[screenSize],
    Border: {
      borderWidth: 1,
      colorBorder: colors.primary[colorMode],
      w: identity,
      h: identity,
    },
    Icon: {
      mount: 0.5,
      x: middle,
      y: middle,
      w: SIZE[screenSize],
      h: SIZE[screenSize],
      visible: false,
      iconData: {
        picto: {
          name: 'CheckLight',
          type: ICON_TYPE.SIMPLE_ICON,
        },
        viewBox: {
          w: ICON_SIZE[screenSize],
          h: ICON_SIZE[screenSize],
        },
      },
    },
  };
};

export const getDisabledStyle = (context = defaultContext) => {
  const { colorMode } = context;

  return {
    color: null,
    Border: {
      colorBorder: colors.primaryDisabled[colorMode],
    },
    Icon: {
      visible: false,
    },
  };
};

export const getCheckedStyle = (context = defaultContext) => {
  const { colorMode } = context;

  return {
    color: colors.primary[colorMode],
    Border: {
      colorBorder: colors.primary[colorMode],
    },
    Icon: {
      visible: true,
    },
  };
};
